import React, { useState } from "react";
import MsHome from "../../Components/Maruti-Suzuki-components/MsHome";
import BannerImage from "../../Components/login-components/banner-image/BannerImage";
import LogoContainer from "../../Components/login-components/logo-container/LogoContainer";
import BottomCard from "../../Components/login-components/bottom-card/BottomCard";
import Individual from "./Individual_Edd";

const EddIndividualFrame = () => {
  return (
    <>
      <BannerImage>
        <LogoContainer />
      </BannerImage>
      <MsHome>
        <div className="md:h-full md:overflow-hidden ">
          <BottomCard stepper={true}>
            <div className="h-full overflow-y-scroll p-2 space-y-4">
              <Individual />
            </div>
          </BottomCard>
        </div>
      </MsHome>
    </>
  );
};
export default EddIndividualFrame;